module.exports = __webpack_public_path__ + "img/阳光决策.0c9b5b18.png";